import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import InfoComponent from '../../../../Alerts/InfoComponent/InfoComponent'
import ConnectorListing from './ConnectorListing/ConnectorListing'
import SelectedConnector from './SelectedConnector/SelectedConnector'
import HmyProducts from '../../../../Headings/HmyProducts'
import * as NO_CONNECTORS from '../../../../Constants/Constants'
import NewConnector from '../../../../Modules/NewConnector/NewConnector'
import PageLoader from '../../../../SharedComponents/PageState/PageLoader'
import { useGetConnectionsQuery } from '../../../../../features/connections/connectionsApi'
import { connectionStatus, CONNECTION_STATUS } from '../../../../../features/connections/connectionStatus'
import useEntitySummaries from '../../../../../features/syncReports/useEntitySummaries'
import { PATH } from '../../../../../app/routes'
import SectionHeader from '../../SectionHeader/SectionHeader'
const DASHBOARD_CONNECTOR_LIMIT = 4
const Connectors = () => {
    const { data: allConnections = [], isLoading, isSuccess } = useGetConnectionsQuery()
    const connections = allConnections.filter((item) => connectionStatus(item) !== CONNECTION_STATUS.EXPIRED)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const selected = connections[selectedIndex] || null
    const summaries = useEntitySummaries(selected)

    if (isLoading) {
        return <PageLoader message="Loading connectors..." />
    }

    return (
        <>
            {summaries.isFetching ? (
                <div className="loaderNewContainer">
                    <div className="loading-spinner"></div>
                </div>
            ) : null}
            <SectionHeader title={<><HmyProducts /> ({connections.length})</>} subtitle="Your active connectors and their sync status">
                <NewConnector />
            </SectionHeader>
            {connections.length > 0 ? (
                <div id="emptyNewconnector" className="row">
                    <div className="col-md-5">
                        <div className="nav flex-column nav-pills dashboard-nav-pills">
                            {connections.slice(0, DASHBOARD_CONNECTOR_LIMIT).map((item, index) => (
                                <ConnectorListing
                                    key={item.id}
                                    connectorIndex={index}
                                    name={item.name}
                                    sourceShortName={item.source.shortName}
                                    targetShortName={item.target.shortName}
                                    isSetupCompleted={item.instances[0].isSetupCompleted}
                                    expiryDate={item.expiryDate}
                                    errorCount={item.instances[0].errorCount}
                                    entityCount={item.instances[0].entityCount}
                                    selectedIndex={selectedIndex}
                                    onSelect={setSelectedIndex}
                                />
                            ))}
                        </div>
                        {connections.length > DASHBOARD_CONNECTOR_LIMIT ? (
                            <div className="buttonContainer text-center d-block">
                                <Link className="btn btn-primary btn-rounded waves-effect waves-light viewmorenewsec" to={PATH.MY_PRODUCTS}>
                                    View More
                                </Link>
                            </div>
                        ) : null}
                    </div>
                    <div className="col-md-7 connection-info no-padding">
                        {selected ? (
                            <SelectedConnector
                                key={selected.id}
                                connection={selected}
                                businessEntitiesSource={summaries.source}
                                businessEntitiesTarget={summaries.target}
                            />
                        ) : null}
                    </div>
                </div>
            ) : isSuccess ? (
                <div id="mainWarningInfo" className="row">
                    <div className="col-md-12">
                        <InfoComponent info={NO_CONNECTORS.NO_CONNECTORS} />
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default Connectors
